import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function PaymentHistory() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = async () => {
    try {
      const { data } = await api.get("/payments/history");
      setPayments(data.payments || []);
    } catch (err) {
      console.error(err);
      toast.error("Unable to load payment history");
    } finally {
      setLoading(false);
    }
  };

  const statusBadge = (status) => {
    switch (status) {
      case "approved":
        return (
          <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-400 text-xs font-semibold">
            Approved
          </span>
        );

      case "pending":
        return (
          <span className="px-3 py-1 rounded-full bg-yellow-500/20 text-yellow-400 text-xs font-semibold">
            Pending
          </span>
        );

      case "rejected":
        return (
          <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-400 text-xs font-semibold">
            Rejected
          </span>
        );

      default:
        return (
          <span className="px-3 py-1 rounded-full bg-gray-500/20 text-gray-300 text-xs font-semibold">
            Unknown
          </span>
        );
    }
  };

  return (
    <div className="card-tactical rounded-2xl p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">
        Payment History
      </h1>

      {loading ? (
        <div className="text-white/60">
          Loading payment history...
        </div>
      ) : payments.length === 0 ? (
        <div className="text-white/60">
          No payment history found.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">

            <thead>
              <tr className="border-b border-white/10 text-left">
                <th className="py-3">Plan</th>
                <th>Amount</th>
                <th>Credits</th>
                <th>Status</th>
                <th>Provider</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {payments.map((payment) => (
                <tr
                  key={payment.id}
                  className="border-b border-white/5"
                >
                  <td className="py-4">
                    {payment.plan_name}
                  </td>

                  <td>
                    ${payment.amount}
                  </td>

                  <td>
                    {payment.credits_added}
                  </td>

                  <td>
                    {statusBadge(payment.status)}
                  </td>

                  <td>
                    {payment.provider || "PayPal"}
                  </td>

                  <td>
                    {payment.created_at
                      ? new Date(
                          payment.created_at
                        ).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
}
